import { Page } from '@/core/architecture'

import { ConsoleLotteryCsvUploadTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleLotteryCsvUpload Page
 * Implemented as a practical sample.
 */
export const ConsoleLotteryCsvUpload: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleLotteryCsvUploadTemplate state={state} {...actions} />
}
